import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { PanelModule } from 'primeng-lts/panel';
import { TableModule } from 'primeng-lts/table';
import { RouterModule } from '@angular/router';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { TableComponentModule } from '../../main-view/table.module';
import { TabViewModule } from 'primeng-lts/tabview';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { CodeInclusionComponent } from './codeInclusion.component';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ButtonModule } from 'primeng-lts/button';
import { CalendarModule } from 'primeng-lts/calendar';
import { ContextMenuModule } from 'primeng-lts/contextmenu';
import { DialogModule } from 'primeng-lts/dialog';
import { DropdownModule } from 'primeng-lts/dropdown';
import { InputTextModule } from 'primeng-lts/inputtext';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { SliderModule } from 'primeng-lts/slider';
import { ToastModule } from 'primeng-lts/toast';
import { DirectivesModule } from '../../directives/directives.module';


@NgModule({
  declarations: [CodeInclusionComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FormsModule,
    FormPlycaModule,
    PanelModule,
    TableModule,
    TableComponentModule,
    WaitLoadingModule,
    TabViewModule,
    OverlayPanelModule,
    SubHeaderModule,
    ScrollPanelModule, WaitLoadingModule, // Servicio  de espera
    TranslateModule,   // Servicio de internacionalización
    CommonModule,
    TableModule,
    DirectivesModule,  // Directivas para dobleclick de botones, autofocus, ...
    OverlayPanelModule,

    BrowserModule,
    BrowserAnimationsModule,

    CalendarModule,
    SliderModule,
    DialogModule,
    MultiSelectModule,
    ContextMenuModule,
    DropdownModule,
    ButtonModule,
    ToastModule,
    InputTextModule,
    ProgressBarModule,
    HttpClientModule,
  ]
})
export class CodeInclusionModule { }
